import { saveAs } from 'file-saver';
import { toast } from "sonner";

/**
 * Exports the journey map as a JSON file for sharing
 * Includes improved error handling and empty field checks
 */
export const exportJourneyAsJSON = (stages: any[], journey: any) => {
  // Create a toast ID for updating the same toast with progress
  const toastId = "json-export-progress";
  
  try {
    // Check if stages array is empty
    if (!stages || stages.length === 0) {
      toast.error("Cannot export: Journey map is empty");
      return;
    }
    
    // Initialize progress
    toast.loading("Preparing JSON export...", { id: toastId });
    
    // Create export data object
    const exportData = {
      stages,
      journey
    };
    
    // Convert to JSON
    toast.loading("Converting to JSON format...", { id: toastId });
    const jsonString = JSON.stringify(exportData, null, 2);
    
    if (!jsonString || jsonString === '{}') {
      throw new Error("Failed to generate valid JSON data");
    }
    
    // Create blob
    const blob = new Blob([jsonString], { type: 'application/json' });
    
    // Create sanitized filename
    const mapName = journey.mapName && journey.mapName.trim() ? 
      journey.mapName.trim() : 
      'journey_map';
    
    const sanitizedMapName = mapName.replace(/[^a-zA-Z0-9\s-_]/g, '_');
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `${sanitizedMapName}_${timestamp}.json`;
    
    // Save file
    toast.loading("Saving JSON file...", { id: toastId });
    saveAs(blob, filename);
    
    toast.success("JSON export complete!", { id: toastId });
  } catch (error) {
    console.error("JSON export error:", error);
    const errorMessage = error instanceof Error ? 
      `Failed to export JSON: ${error.message}` : 
      "Failed to export journey map";
    toast.error(errorMessage, { id: toastId });
  }
};
